import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-xhr-backend";
import { initReactI18next } from "react-i18next";

const I18N_URL = process.env.REACT_APP_I18N_URL || "https://onmo-admin-upload-dev.s3.amazonaws.com/public/i18n/";

i18n
  // load translation using xhr -> see /public/locales
  // learn more: https://github.com/i18next/i18next-xhr-backend
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    load: "languageOnly",
    fallbackLng: "en",
    defaultNS: "common",
    debug: false,
    ns: ["common"],
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    backend: {
      loadPath: (lng: any, ns: any) => {
        return `${I18N_URL}${lng}/${ns}.json`;
      },
      crossDomain: true,
    },
    keySeparator: "",
    detection: {
      order: ["querystring", "cookie", "header"],
      lookupCookie: "lang",
      lookupQuerystring: "lang",
      caches: ["cookie"],
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
